import { TranslateLoader } from "@ngx-translate/core";
import { Observable } from "rxjs";
import { LanguageService } from "src/app/shared/services/language.service";

export class CustomI18nTranslateLoader implements TranslateLoader {
  constructor(private languageService: LanguageService) {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public getTranslation(lang: string): Observable<any> {
    return this.languageService.getTranslation(lang);
  }
}
